import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useInView, type UseInViewOptions } from 'motion/react';
interface UseIsInViewOptions {
  inView?: boolean;
  inViewOnce?: boolean;
  inViewMargin?: UseInViewOptions['margin'];
}
function useIsInView(ref, t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    inView,
    inViewOnce: t2,
    inViewMargin: t3
  } = options;
  const inViewOnce = t2 === undefined ? false : t2;
  const inViewMargin = t3 === undefined ? "0px" : t3;
  const localRef = React.useRef(null);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => localRef.current as T;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  React.useImperativeHandle(ref, t4);
  let t5;
  if ($[3] !== inViewMargin || $[4] !== inViewOnce) {
    t5 = {
      once: inViewOnce,
      margin: inViewMargin
    };
    $[3] = inViewMargin;
    $[4] = inViewOnce;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const inViewResult = useInView(localRef, t5);
  const isInView = !inView || inViewResult;
  let t6;
  if ($[6] !== isInView) {
    t6 = {
      ref: localRef,
      isInView
    };
    $[6] = isInView;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
export { useIsInView, type UseIsInViewOptions };